/** 比较项配置弹出框 */
<template>
  <el-popover
    placement="bottom"
    :width="160"
    :visible="visible"
    popper-class="tab-popover"
  >
    <template #reference>
      <div>
        <i class="iconfont icon-peizhiguanli"></i>
        比较项配置({{ displayComparisonItemsList.length }})
      </div>
    </template>
    <template #default>
      <div class="tab-list">
        <div
          class="tab-text"
          v-for="(item, index) in comparisonItemsList"
          :key="item"
          draggable="true"
          @dragstart="handleDragStart(index)"
          @dragenter="handleDragEnter"
          @dragover="handleDragOver"
          @dragleave="handleDragLeave"
          @drop="handleDrop(index)"
          @dragend="handleDragEnd"
        >
          <div class="text-item">
            <i class="iconfont icon-yidongshu" style="margin-right: 3px"></i>
            <div
              :class="[
                item.show == COMPARE_TITLE_VISIBLE.HIDE ? 'close-eye' : '',
              ]"
            >
              <div class="ellipsis-container">
                <span class="ellipse-text">{{ item.label }}</span>
              </div>
            </div>
          </div>
          <div
            :class="[
              'eye-icon',
              item.show == COMPARE_TITLE_VISIBLE.SHOW ? 'close-eye' : '',
            ]"
          >
            <span @click="handleChangeShow(item)">
              <i
                class="iconfont icon-yuedukejian"
                v-if="item.show == COMPARE_TITLE_VISIBLE.SHOW"
              ></i>
              <i class="iconfont icon-biyan" v-else></i>
            </span>
            <span
              @click="handleClickRemove(item)"
              v-if="item.type == COMPARE_TITLE_TYPE.CUSTOM"
              style="margin-left: 3px"
            >
              <i class="iconfont icon-cuowu"></i>
            </span>
          </div>
        </div>
      </div>
      <hr />
      <PopperAddCompare
        v-model:visible="popoverCardVisible"
        :placement="'right'"
        @add="handClickAddOption"
      >
        <template #content>
          <div class="tab-text" @click="openCard">
            <div>
              <i class="iconfont icon-icon-10" style="font-size: 12px"></i>
              新增比较项
            </div>
          </div>
        </template>
      </PopperAddCompare>
    </template>
  </el-popover>
</template>

<script setup>
import {
  ref,
  nextTick,
  defineProps,
  defineEmits,
  inject,
  onMounted,
  watch,
  defineExpose,
} from "vue";
import PopperAddCompare from "./PopperAddCompare.vue";
import { httpPost } from "@/api/httpService.js";
import { confirmBox } from "@/utils/messageBox.js";
import { bus } from "@/utils/mitt.js";
import { ElMessage } from "element-plus";
import {
  COMPARE_TITLE_VISIBLE,
  COMPARE_TITLE_TYPE,
} from "@/constant/compare.js";

const emits = defineEmits(["update:visible", "update", "loading"]);
const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  comparisonItems: {
    type: Array,
    default: () => [],
  },
  id: {
    type: String,
    default: "",
  },
});
//获取配置项数据
const comparisonItemsList = ref([]);
const comparisonUid = ref("");
const displayComparisonItemsList = ref([]);
//获取配置项显示的列表
const getDisplayComparisonItemsList = () => {
  displayComparisonItemsList.value = comparisonItemsList.value.filter(
    (item) => {
      return item.show == COMPARE_TITLE_VISIBLE.SHOW;
    }
  );
};
watch(
  () => props.comparisonItems,
  (newVal, oldVal) => {
    comparisonItemsList.value = newVal;
    getDisplayComparisonItemsList();
  },
  { immediate: true, deep: true }
);
watch(
  () => props.id,
  (newVal, oldVal) => {
    comparisonUid.value = newVal;
  },
  { immediate: true, deep: true }
);
//是否展示
const handleChangeShow = async (item) => {
  item.show =
    item.show === COMPARE_TITLE_VISIBLE.SHOW
      ? COMPARE_TITLE_VISIBLE.HIDE
      : COMPARE_TITLE_VISIBLE.SHOW;
  await handleChangeOperate();
  getDisplayComparisonItemsList();
  emits("update", { type: "VISIBLE", data: displayComparisonItemsList.value });
};
//文献对比比较项配置（顺序变化、对比项隐藏和显示、添加对比项）
const handleChangeOperate = async () => {
  emits("loading", true);
  let title = comparisonItemsList.value.map((element) => {
    const { label, ...rest } = element;
    return rest;
  });
  let params = {
    comparisonUid: comparisonUid.value,
    title: title,
  };
  let res = await httpPost("/comparison/v1/updateComparisonTitle", params);
  if (res.code == 0) {
    ElMessage.success("操作成功");
  }
  emits("loading", false);
};
//删除比较项
const handleClickRemove = (item) => {
  confirmBox("确认删除该比较项吗？").then(async () => {
    let index = comparisonItemsList.value.indexOf(item);
    comparisonItemsList.value.splice(index, 1);
    await handleChangeOperate();
    getDisplayComparisonItemsList();
    emits("update", { type: "REMOVE", data: displayComparisonItemsList.value });
  });
};
//添加自定义比较项
const handClickAddOption = async (params) => {
  const comparisonItem = comparisonItemsList.value.find((item) => {
    return item.label == params.label;
  });
  if (comparisonItem) {
    ElMessage.warning("该比较项已存在");
    return;
  }
  comparisonItemsList.value.push(params);
  await handleChangeOperate();
  getDisplayComparisonItemsList();
  emits("update", { type: "ADD", data: displayComparisonItemsList.value });
};
//拖拽
//#region
const draggingIndex = ref("");
const handleDragStart = (index) => {
  //获取拖拽的元素
  draggingIndex.value = index;
};
const handleDragEnter = (event) => {
  // 可拖动元素进入
  event.preventDefault();
  event.target.classList.add("drag-enter");
};
const handleDragOver = (event) => {
  // 阻止默认行为以允许放置
  event.preventDefault();
};
const handleDragLeave = (event) => {
  //  可拖动元素离开
  event.target.classList.remove("drag-enter");
};
const handleDrop = async (index) => {
  //将被拖动元素移动到选定的目标元素中
  const draggingItem = comparisonItemsList.value[draggingIndex.value];
  comparisonItemsList.value.splice(draggingIndex.value, 1);
  comparisonItemsList.value.splice(index, 0, draggingItem);
  await handleChangeOperate();
  emits("update", { type: "DROP", data: displayComparisonItemsList.value });
};
const handleDragEnd = () => {
  //  拖动结束
  draggingIndex.value = null;
};
//#endregion
//打开新增比较项的卡片
const popoverCardVisible = ref(false);
const openCard = () => {
  popoverCardVisible.value = true;
};
const closeCard = () => {
  popoverCardVisible.value = false;
};

defineExpose({ closeCard });
</script>

<style lang="scss" scoped>
.tab-popover {
  .tab-list {
    max-height: 400px;
    overflow-y: auto;
  }
  .tab-text {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 24px;
    cursor: pointer;
    padding: 2px 5px;
    font-size: 13px;
    margin: 4px 0;
    border-radius: 5px;
    .text-item {
      display: flex;
      .ellipsis-container {
        width: 90px;
        @include hidden-with-ellipsis();
      }
    }
  }
  .eye-icon {
    display: none;
  }
  .close-eye {
    color: rgb(173, 173, 173);
  }
  .tab-text:hover {
    background-color: #f5f5f5;
    .eye-icon {
      display: block;
    }
  }
  .iconfont {
    font-size: 13px;
  }
  hr {
    margin: 3px 0;
    height: 1px;
    border: none;
    border-top: 1px solid #eaeaea;
  }
}
</style>
